<template>
	<modal ref="modal" size="modal-lg">
		<template #title>STOCK REMINDER</template>
		<template #body>
			<div class="mt-3 pb-4 border-bottom">
				<div class="form-floating mb-4">
					<textarea v-model="form.email_message" type="text" id="email_message" name="email_message" class="form-control" placeholder="Email Reminder Message" style="height: 150px;"></textarea>
					<label class="form-label" for="email_message">Email Reminder Message</label>
					<div v-if="form.errors.email_message && (form.email_message=='' || form.email_message==null)" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.email_message }}
					</div>
				</div>
				<div v-if="['P','PC','PF'].includes(rankPrefix)" class="form-floating mb-4">
					<textarea v-model="form.sms_message" type="text" id="sms_message" name="sms_message" class="form-control" placeholder="SMS Reminder Message" maxlength="160" style="height: 100px;"></textarea>
					<label class="form-label" for="sms_message">SMS Reminder Message</label>
					<div class="text-danger fw-bold">Max Length: {{remain_char}}/160</div>
					<div v-if="form.errors.sms_message && (form.sms_message=='' || form.sms_message==null)" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.sms_message }}
					</div>
				</div>
				<div class="form-floating mb-4">
					<input v-model="form.date_remind" type="date" id="date_remind" name="date_remind" class="form-control" placeholder="Date Remind" />
					<label class="form-label" for="date_remind">Date Remind</label>
					<div v-if="form.errors.date_remind && (form.date_remind=='' || form.date_remind==null)" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.date_remind }}
					</div>
				</div>
				<div class="form-floating mb-4">
					<input v-model="form.time_remind" type="time" id="time_remind" name="time_remind" class="form-control" placeholder="Time Reminder" />
					<label class="form-label" for="time_remind">Time Remind</label>
					<div v-if="form.errors.time_remind && (form.time_remind=='' || form.time_remind==null)" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.time_remind }}
					</div>
				</div>
				<div class="form-floating mb-4">
					<select v-model="form.is_active" id="is_active" name="is_active" class="form-control" placeholder="Status">
	                  <option value="1">ON</option>
	                  <option value="0">OFF</option>
	                </select>
					<label class="form-label" for="is_active">Status</label>
					<div v-if="form.errors.is_active && (form.is_active=='' || form.is_active==null)" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.is_active }}
					</div>
				</div>

				<div class="my-2 text-center">
					<button  @click="actionContent" type="submit" class="btn btn-alt-primary" :disabled="form.processing">
						<span v-if="!form.processing"><i class="fa fa-save me-1"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Reminder</span>
							<span v-else>
								<div class="spinner-border spinner-border-sm text-dark" role="status" >
									<span class="sr-only mr-1">Please wait...</span>
								</div>
								<span class="mx-2">Please wait...</span>
							</span>
					</button>
					<button v-if="cur_index!=null" @click="cancelEdit" type="button" class="btn btn-alt-secondary ms-2" :disabled="form.processing">
						<i class="fa fa-times me-1"></i>Cancel
					</button>
				</div>
			</div>

			<div class="my-4">
				<p class="m-0 text-danger fw-bold">NOTE: Only 
					<span v-if="['P','PC','PF'].includes(rankPrefix)">4</span> 
					<span v-else-if="['D'].includes(rankPrefix)">3</span> 
					<span v-else>2</span> 
					reminder are allowed per month.</p>
				<div class="table-responsive">
					<table class="table table-borderless" :class="{'table-hover':cur_index==null}">
						<thead>
							<tr class="bg-default">
								<th>Message</th>
								<th v-if="['P','PF'].includes(rankPrefix)">SMS Message</th>
								<th>Date</th>
								<th>Time</th>
								<th>Has Reminded</th>
								<th>Status</th>
								<th class="text-end">::::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(stock,s_index) in stockReminders.data" :class="{'bg-selected':cur_index==s_index}">
								<td>{{stock.email_msg_short}}</td>
								<td v-if="['P','PF'].includes(rankPrefix)">{{stock.sms_msg_short}}</td>
								<td>{{stock.date_remind_format}}</td>
								<td>{{stock.time_remind_format}}</td>
								<td>
									<span class="badge" :class="{'bg-success':stock.has_remind==1,'bg-danger':stock.has_remind==0}">{{stock.has_remind_format}}</span>
								</td>
								<td>
									<span class="badge" :class="{'bg-success':stock.is_active==1,'bg-danger':stock.is_active==0}">{{stock.is_active_format}}</span>
								</td>
								<td class="text-end">
									<button v-if="cur_index==null && stock.has_remind==0" @click="editReminder(s_index)" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
									<button v-if="stock.has_remind==1" type="button" class="btn btn-sm btn-alt-secondary disabled"><i class="fa fa-pencil-alt"></i></button>
									<span v-if="cur_index==s_index" class="fw-bold text-danger">Selected</span>
								</td>
							</tr>
							<tr v-if="stockReminders.data.length<=0">
								<td colspan="6">
									<p class="my-3 text-center h6 text-danger">NO RECORD FOUND</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

		</template>
		<template #footer>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				<i class="fa fa-times me-1"></i>Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props:{
		rankPrefix		: String,
		stockReminders 	: Object
	},
	emits: 'changeAction',
	setup(props,{emit}) {
		const modal = ref(null)

		const toggleModal = () => {
			cancelEdit();
			modal.value.toggleModal();
		}


		const cur_index 		= ref(null);
		const action 			= ref('add');

		const sms_msg_len 		= ref(160);

		const remain_char 		= ref(sms_msg_len.value);

		const form = useForm({
			stock_reminder_uuid : 0,
			email_message 	: '',
			sms_message 	: '',
			date_remind		: '',
			time_remind		: '',
			is_active 		: 0,
		})

		const editReminder = (_index)=>{
			cur_index.value 			= _index;
			action.value 				= 'update';

			remain_char.value 			= sms_msg_len.value;

			form.stock_reminder_uuid 	= props.stockReminders.data[_index].stock_reminder_uuid;
			form.email_message 			= props.stockReminders.data[_index].email_message;
			form.sms_message 			= props.stockReminders.data[_index].sms_message;
			form.date_remind 			= props.stockReminders.data[_index].date_remind;
			form.time_remind 			= props.stockReminders.data[_index].time_remind;
			form.is_active 				= props.stockReminders.data[_index].is_active;

			$("#email_message").focus();
		}

		const cancelEdit = ()=>{
			cur_index.value = null;
			action.value 	= 'add';

			remain_char.value 			= sms_msg_len.value;

			form.stock_reminder_uuid 	= 0;
			form.email_message 			= '';
			form.sms_message 			= '';
			form.date_remind 			= '';
			form.time_remind 			= '';
			form.is_active 				= 0;
		}

		const actionContent = ()=>{

			emit('changeAction', action.value);

			if(action.value=='add')
			{
				addReminder();
			}else
			{
				updateReminder();	
			}

		}

		const addReminder = () => {
			form.post(route('member.recommendations.post-stock-set-reminder'), {
				preserveState: true,
				preserveScroll: true,
				only:['stockReminders,api_response,errors'],
				onSuccess: () => {
					form.reset();
				},
			})
		}

		const updateReminder = () => {
			form.put('stock/set-reminder/'+form.stock_reminder_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['stockReminders,api_response,errors'],
				onSuccess: () => {
					form.reset();
					cancelEdit();
				},
			})
		}

		watch(()=>form.sms_message,(value)=>{
			if(value!=null)
			{
				remain_char.value = 160 - value.length;		
			}
		})

		return {
			sms_msg_len,
			remain_char,
			cur_index,
			form,
			modal,
			toggleModal,
			action,
			editReminder,
			cancelEdit,
			actionContent,
			addReminder,
			updateReminder,
		}
	},
}
</script>
